export const generateCompactStyles = ({ colors = {}, dimensions = {}, fontSpacing = {
    letterSpacing: { value: 0, unit: 'px' },
    lineHeight: { value: 1.5, unit: 'em' },
    wordSpacing: { value: 0, unit: 'px' }
} }) => `
.radio-player.compact {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto auto auto;
    width: ${dimensions?.width || '400px'};
    max-width: 100%;
    padding: 15px 15px 5px 15px;
    position: fixed;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
    z-index: 9999;
    overflow: visible;
}

.radio-player.compact .album-artwork {
    width: 90px;
    height: 90px;
    grid-row: 1 / span 3;
    margin-right: 5px;
    border-radius: 4px;
    overflow: hidden;
}

.radio-player.compact .compact-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-column: 2 / span 2;
    gap: 5px;
    padding-top: 5px;
}

.radio-player.compact .radio-name {
    font-size: 14px;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.compact .live-container {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 4px 8px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.3);
}

.radio-player.compact .live-text {
    font-size: 14px;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.compact .song-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
    grid-column: 2;
    padding: 5px 0;
}

.radio-player.compact .song-name {
    font-size: 16px;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.compact .artist-name {
    font-size: 14px;
    opacity: 0.8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.radio-player.compact .controls-container {
    grid-column: 3;
    justify-self: end;
    position: relative;
    overflow: visible;
}

.radio-player.compact .controls {
    display: flex;
    align-items: center;
    gap: 5px;
}

.radio-player.compact .time-info {
    grid-column: 1 / -1;
    display: flex;
    justify-content: space-between;
    padding: 2 0;
    margin: 0;
    margin-top: 2px;
    font-size: 14px;
}

.radio-player.compact .time-bar-container {
    grid-column: 1 / -1;
    width: 100%;
    height: 3px;
    margin: 0;
    margin-top: 2px;
}

.radio-player.compact .time-bar {
    width: 100%;
    height: 100%;
    background: ${colors.timeBar ? `${colors.timeBar}33` : 'transparent'};
    border-radius: 1.5px;
    overflow: hidden;
}

.radio-player.compact .time-bar-progress {
    height: 100%;
    background: ${colors.timeBar || '#333333'};
    border-radius: 1.5px;
}

.radio-player.compact .volume-bar-container {
    position: absolute;
    bottom: calc(100% + 5px);
    left: 50%;
    transform: translate(90%, 15px);
    background: ${colors?.background || 'rgba(0, 0, 0, 0.9)'};
    padding: 12px 8px;
    border-radius: ${dimensions?.borderRadius || '12px'};
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
    z-index: 10000;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: default;
    height: 100px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.radio-player.compact .volume-bar-container:before {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translate(45%, 15px);;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${colors?.background || 'rgba(0, 0, 0, 0.9)'};
}

.radio-player.compact .volume-bar-container.show {
    opacity: 1;
    visibility: visible;
}

.radio-player.compact .volume-slider {
    -webkit-appearance: none;
    width: 80px;
    height: 4px;
    background: ${colors?.timeBar ? `${colors.timeBar}40` : 'rgba(255, 255, 255, 0.2)'};
    border-radius: 2px;
    outline: none;
    transform: rotate(-90deg);
    transform-origin: center;
    margin: 0;
    cursor: pointer;
    position: absolute;
}

.radio-player.compact .volume-button {
    position: relative;
    overflow: visible;
}

.radio-player.compact .control-button {
    padding: 5px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
}

.radio-player.compact .control-button.play-button {
    width: calc(36px * 1.3);
    height: calc(36px * 1.3);
    font-size: 1.5rem;
}

.radio-player.compact .control-button .fa-play {
    margin-left: 2px;
    font-size: inherit;
}

.radio-player.compact .control-button .fa-pause {
    font-size: inherit;
}

/* History Modal Styles */
.history-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99999;
    display: none;
    font-family: 'Poppins', sans-serif;
}

.history-modal.visible {
    display: block;
}

.history-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99999;
}

.history-modal-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${colors.historyModalBg || colors.background || '#1e1e1e'};
    padding: 1.45rem;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
    z-index: 100000;
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
    font-family: 'Poppins', sans-serif;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

/* WebKit scrollbar styles */
.history-modal-content::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.history-modal-content::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 3px;
}

.history-modal-content::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
    transition: background 0.2s;
}

.history-modal-content::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
}

.history-modal-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: ${colors.historyModalTexts || colors.text || '#ffffff'} !important;
    margin: 0 0 0.97rem 0;
    padding-right: 1.45rem;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.history-modal-close {
    position: absolute;
    top: 0.97rem;
    right: 0.97rem;
    background: none;
    border: none;
    color: ${colors.historyModalTexts || colors.text || '#ffffff'} !important;
    cursor: pointer;
    padding: 0.387rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
}

.history-modal-close:hover {
    background: rgba(255, 255, 255, 0.1);
}

.history-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.history-item {
    display: flex;
    gap: 1rem;
    align-items: center;
    padding: 0.5rem;
    border-radius: 8px;
    transition: background-color 0.2s;
}

.history-item:hover {
    background: rgba(255, 255, 255, 0.05);
}

.history-artwork {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
}

.history-artwork img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.history-song-info {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.history-song-title {
    font-size: 0.875rem;
    font-weight: 500;
    color: ${colors.historyModalTexts || colors.text || '#ffffff'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.history-artist-name {
    font-size: 0.75rem;
    color: ${colors.historyModalTexts ? `${colors.historyModalTexts}99` : colors.text ? `${colors.text}99` : '#ffffff99'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}
`; 